import { useMemo } from 'react';

import { ClipSource } from '@air/api/types';
import { useSysadmin } from '@air/sysadmin';

import { IMPORT_SOURCES, INTERNAL_IMPORT_SOURCES } from '~/constants/importSource';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { type ImportSourceType } from '~/utils/ImportUtils';
import { useExcludedIntegrationsFlag } from './flags/useExcludedIntegrationsFlag';

export const useExposeImportSources = () => {
  const { isInternal } = useSysadmin();
  const { showSharePointImportSource } = useFeatureFlags();
  const { excludedImportSources } = useExcludedIntegrationsFlag();

  const exposeImportSources = useMemo<ImportSourceType[]>(() => {
    const sources = isInternal
      ? [...IMPORT_SOURCES, ...INTERNAL_IMPORT_SOURCES]
      : showSharePointImportSource
        ? [...IMPORT_SOURCES, ClipSource.sharePoint as ImportSourceType]
        : IMPORT_SOURCES;

    return sources.filter((source) => !excludedImportSources.includes(source));
  }, [isInternal, showSharePointImportSource, excludedImportSources]);

  return { exposeImportSources };
};
